import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';

interface DeleteEvaluationResponse {
  message: string;
  evalId: string;
}

export const deleteEvaluation = async (
  evalId: string,
): Promise<DeleteEvaluationResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  const response = await apiRequest<DeleteEvaluationResponse>({
    url: `/evaluations/${orgId}/${evalId}`,
    target: 'platform',
    method: 'DELETE',
  });
  return response?.data as DeleteEvaluationResponse;
};
